import { PERK_REDEMPTION_STATUS } from "~constants/status"

export interface Redemption {
  id: string
  perkId: string
  perkCode: string
  perkName: string
  perkLogo: string
  perkDescription: string
  perkShortDescription: string
  type: string
  redeemedBy: string
  redeemedById: string
  userEmail: string
  createdAt: string
  createdById?: string
  updatedAt: string
  bookingFirstName?: string
  bookingLastName?: string
  bookingEventDate?: string
  bookingId?: string
  cclShipName?: string
  status: PERK_REDEMPTION_STATUS
  invalidationDetails?: string
  invalidationReason?: string
  cclOnboardCreditCurrency?: string
  cclOnboardCreditValue?: string
  proofOfOwnershipName?: string
  updatedByEmail?: string
}

export enum ActionType {
  FILL_FORM = "FILL_FORM",
}

export interface RedemptionFlow {
  perkCode: string
  steps: RedemptionStep[]
  id: number
  createdAt: string
  updatedAt: string
}

export interface RedemptionStep {
  action: ActionType
  formId: string
  id: number
  createdAt: string
  updatedAt: string
}

export type PartialRedemption = {
  redemptionDate: string
  perkName: string
  redeemedBy: string
  bookingName?: string
  bookingNumber?: string
  bookingDate?: string
  status?: string
}
